module.exports = [{"title":"K-beauty and J-beauty brands","images":["tatcha","amore-pacific","tony-moly","dr-jart"]},{"title":"Luxury brands","images":["estee-lauder","la-prairie","skii","la-mer"]},{"title":"Prestige brands","images":["caudalie","sunday-riley","drunk-elephant","ole-hendriksen"]},{"title":"Organic brands","images":["tata-harper","boscia","ren","youth-to-the-people"]},{"title":"Mass beauty brands","images":["cetaphil","aveeno","cerave","neutrogena"]},{"title":"Clinical brands","images":["dr-dennis-gross","skinceuticals","dr-brandt","peter-thomas-roth"]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/onboarding-brands.json
// module id = 1551
// module chunks = 0